require('./cardRequestAdditionalStep1.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @ commons
const { FormattedText } = require('core/i18n').i18n;

// @ components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const DropdownInterveners = require('components/contactCenter/dropdownInterveners/dropdownInterveners');
const { OKMessage } = require('commonsComponents/OKMessage');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')

// @ utilities
const { findAccountName, getFormattedAccountNumber } = require('utilities/contactCenter/cardRequestAdditionalHelper');

class CardRequestAdditionalStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { immStep, immAccounts, onSelectIntervener } = this.props;
        const immAssociatedAccount = immStep.get('associatedAccount');
        const immInterveners = immStep.get('interveners');
        const intervenerId = immStep.get('intervenerId').toJS();
        const initialIntervenerId = immInterveners.getIn([0, 'intervenerId']).toJS();
        const accountName = findAccountName(immAccounts, immAssociatedAccount);
        const accountNumber = getFormattedAccountNumber(immAssociatedAccount);

        return (
            <div className="card-request-additional-step-1">
                <h4 className="card-request-additional-step-1__title wizard-step--vertical__title">
                    <FormattedText value="cardRequestAdditionalStep1-title" />
                </h4>
                <div className="card-request-additional-step-1__body">
                    <BlockInfo>
                        <p>
                            <FormattedText
                                className="card-request-additional-step-1__intervener-selection-script"
                                value="cardRequestAdditionalStep1-intervenerSelectionScript"
                            />
                            <FormattedText
                                className="card-request-additional-step-1__intervener-selection-script card-request-additional-step-1__intervener-selection-script--strong"
                                value="cardRequestAdditionalStep1-accountName"
                                injectedStrings={[ accountName, accountNumber ]}
                            />
                        </p>
                    </BlockInfo>
                    <ContactCenterRender>
                        <OKMessage type="informative">
                            <FormattedText value="cardRequestAdditionalStep1-onlyIntervenerMessage" />
                        </OKMessage>
                    </ContactCenterRender>
                    <div className="card-request-additional-step-1__interveners-dropdown">
                        <DropdownInterveners
                            id="card-request-additional-step-1-dropdown-interveners"
                            immInterveners={immInterveners}
                            initialIntervenerId={initialIntervenerId}
                            currentIntervenerId={intervenerId}
                            onIntervenerChange={onSelectIntervener}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

CardRequestAdditionalStep1.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immStep: PropTypes.object.isRequired,
    onSelectIntervener: PropTypes.func.isRequired,
};

module.exports = CardRequestAdditionalStep1;
